module.exports = __webpack_public_path__ + "img/empty-box.463a20d7.svg";